// src/utils/axiosInstance.js
import axios from 'axios';

const axiosInstance = axios.create();

// اضافه کردن توکن به همه درخواست‌ها
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosInstance;